import { kiosk } from './kiosk';
import { images as hunter } from './hunter';
import { images as valuation } from './valuation';
import { images as vehicleOEMs } from './vehicleOEMs';

export const images = {
    kiosk,
    hunter,
    valuation,
    vehicleOEMs,
};
